import { Link } from "react-router-dom";
import type { HdmgdjConfig } from "@/config/hdmgdjConfig";

interface HdmgdjHeroProps {
  config: HdmgdjConfig;
}

const SHOT_HOME =
  "/images/screenshot-1.jpeg";
const SHOT_FEATURED =
  "/images/screenshot-2.jpeg";
const SHOT_WISH =
  "/images/screenshot-5.jpeg";
const HDMGDJ_MASCOT =
  "/images/mascot-hero.png";

const HDMGDJ_TICKER = [
  "经典魔改 每日爆更",
  "全平台免费畅看",
  "1080P 高清秒开",
  "离线缓存 随时随地",
  "云端同步 换机不丢剧",
  "大神精选 编辑推荐",
  "心愿榜单 全民投票",
];

export default function HdmgdjHero({ config }: HdmgdjHeroProps) {
  return (
    <section id="hdmgdj-top" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="hdmgdj-atmos" aria-hidden="true" />
      <div className="hdmgdj-grid-lines" aria-hidden="true" />

      <div className="hdmgdj-container relative z-10 hdmgdj-top-pad pb-14 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-[1.05fr_1fr] gap-14 lg:gap-6 items-center">
          {/* 文案区：首屏按钮不做入场隐藏，保证任何时候都可见可点 */}
          <div>
            <span className="inline-flex items-center gap-2 h-8 px-3.5 rounded-full bg-primary-500/12 border border-primary-500/35 text-primary-300 text-[13px] font-label">
              <i className="ri-verified-badge-fill text-base" />
              全平台免费畅看
            </span>

            <h1 className="mt-5 md:mt-6 font-heading text-background-50 leading-[1.08] text-[36px] sm:text-[52px] md:text-[68px] tracking-wide">
              <span className="text-primary-500">黄豆</span>魔改短剧
            </h1>

            <p className="mt-6 max-w-xl text-[15px] md:text-[16px] leading-8 text-background-200">
              {"黄豆魔改短剧把熟悉的经典桥段重新演绎，反转密集、节奏明快。想要畅快开追，直接完成"}
              <span className="text-primary-300 font-medium">{"黄豆魔改短剧APP下载"}</span>
              {"，或使用"}
              <span className="text-primary-300 font-medium">{"黄豆魔改短剧免费版下载"}</span>
              {"，Android、iOS、HarmonyOS、Windows 全端同步。"}
            </p>

            <div className="mt-7 md:mt-8 flex flex-wrap items-center gap-3 md:gap-4">
              <Link
                to="/hdmgdj-download"
                className="inline-flex items-center gap-2 h-12 md:h-[52px] px-7 rounded-md bg-primary-500 text-foreground-950 text-[16px] font-label font-bold whitespace-nowrap hover:bg-primary-400 transition-colors cursor-pointer"
              >
                <i className="ri-download-2-line text-xl" />
                免费下载APP
              </Link>
              <a
                href="#hdmgdj-shots"
                className="inline-flex items-center gap-2 h-12 md:h-[52px] px-6 rounded-md border border-background-50/25 text-background-100 text-[15px] font-label whitespace-nowrap hover:border-primary-500 hover:text-primary-300 transition-colors cursor-pointer"
              >
                <i className="ri-smartphone-line text-xl" />
                查看软件截图
              </a>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3">
              {config.platforms.map((p) => (
                <span
                  key={p.key}
                  className="inline-flex items-center gap-2 text-[13px] font-label text-background-200/85"
                >
                  <i className={`${p.icon} text-base text-primary-400`} />
                  {p.shortName}
                </span>
              ))}
            </div>
          </div>

          {/* 手机实拍簇 */}
          <div className="relative h-[430px] sm:h-[500px] md:h-[560px]">
            <div
              className="absolute left-1/2 -translate-x-1/2 top-6 md:top-10 w-[300px] md:w-[400px] h-[300px] md:h-[400px] rounded-full bg-primary-500/18 blur-[100px]"
              aria-hidden="true"
            />

            <div className="absolute left-0 top-20 md:top-24 w-[104px] sm:w-[134px] md:w-[168px] -rotate-6">
              <div className="hdmgdj-phone">
                <img
                  src={SHOT_FEATURED}
                  alt="黄豆魔改短剧精选片库界面截图"
                  title="黄豆魔改短剧-精选片库"
                  className="w-full h-auto"
                />
              </div>
            </div>

            <div className="absolute right-0 top-20 md:top-24 w-[104px] sm:w-[134px] md:w-[168px] rotate-6">
              <div className="hdmgdj-phone">
                <img
                  src={SHOT_WISH}
                  alt="黄豆魔改短剧心愿榜单界面截图"
                  title="黄豆魔改短剧-心愿榜单"
                  className="w-full h-auto"
                />
              </div>
            </div>

            <div className="absolute left-1/2 -translate-x-1/2 top-0 w-[148px] sm:w-[188px] md:w-[234px] z-10">
              <div className="hdmgdj-phone hdmgdj-float-slow">
                <img
                  src={SHOT_HOME}
                  alt="黄豆魔改短剧首页界面截图"
                  title="黄豆魔改短剧-首页推荐"
                  className="w-full h-auto"
                />
              </div>
            </div>

            <img
              src={HDMGDJ_MASCOT}
              alt="黄豆魔改短剧吉祥物"
              title="黄豆魔改短剧吉祥物"
              className="absolute left-0 bottom-0 w-[110px] sm:w-[140px] md:w-[172px] z-20 hdmgdj-float"
            />
          </div>
        </div>
      </div>

      {/* 金色跑马灯 */}
      <div className="relative border-y border-primary-500/25 bg-primary-500/[0.07] py-3.5 overflow-hidden">
        <div className="hdmgdj-marquee">
          {[0, 1].map((dup) => (
            <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
              {HDMGDJ_TICKER.map((text) => (
                <span
                  key={text}
                  className="flex items-center gap-3 px-5 md:px-7 text-[13px] md:text-[14px] font-label text-primary-300 whitespace-nowrap"
                >
                  <i className="ri-sparkling-fill text-[9px] text-primary-500" />
                  {text}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}